import React, { useState } from 'react';

interface FranchiseeFormProps {
  enterprises: any[];
  onSubmit: (formData: any) => Promise<void>;
  onCancel: () => void;
  initialData?: any;
}

const FranchiseeForm: React.FC<FranchiseeFormProps> = ({ enterprises, onSubmit, onCancel, initialData }) => {
  const [formData, setFormData] = useState({
    name: initialData?.name || '',
    legalName: initialData?.legalName || '',
    enterpriseId: initialData?.enterpriseId || '',
    email: initialData?.contactInfo?.email || initialData?.email || '',
    phone: initialData?.contactInfo?.phone || initialData?.phone || '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!formData.name.trim() || !formData.enterpriseId) {
      alert('Franchisee name and enterprise are required');
      return;
    }

    setIsSubmitting(true);
    try {
      await onSubmit({
        ...formData,
        type: 'franchisee'
      });
    } catch (error) {
      console.error('Error submitting form:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleChange = (field: string, value: string) => {
    setFormData(prev => ({
      ...prev,
      [field]: value,
    }));
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="label-modern">Franchisee Name *</label>
        <input
          type="text"
          className="input-modern"
          placeholder="Enter franchisee name"
          value={formData.name}
          onChange={(e) => handleChange('name', e.target.value)}
          required
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Legal Name</label>
        <input
          type="text"
          className="input-modern"
          placeholder="Legal business name"
          value={formData.legalName}
          onChange={(e) => handleChange('legalName', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Enterprise *</label>
        <select
          className="input-modern"
          value={formData.enterpriseId}
          onChange={(e) => handleChange('enterpriseId', e.target.value)}
          required
        >
          <option value="">Select Enterprise</option>
          {enterprises.map(ent => (
            <option key={ent.enterpriseId} value={ent.enterpriseId}>{ent.name}</option>
          ))}
        </select>
      </div>
      <div className="form-group">
        <label className="label-modern">Contact Email</label>
        <input
          type="email"
          className="input-modern"
          placeholder="contact@franchisee.com"
          value={formData.email}
          onChange={(e) => handleChange('email', e.target.value)}
        />
      </div>
      <div className="form-group">
        <label className="label-modern">Phone</label>
        <input
          type="tel"
          className="input-modern"
          placeholder="(555) 123-4567"
          value={formData.phone}
          onChange={(e) => handleChange('phone', e.target.value)}
        />
      </div>
      <div className="modal-footer">
        <button
          type="button"
          className="btn-modern btn-modern-secondary"
          onClick={onCancel}
          disabled={isSubmitting}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="btn-modern btn-modern-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? (initialData ? 'Updating...' : 'Creating...') : (initialData ? 'Update Franchisee' : 'Create Franchisee')}
        </button>
      </div>
    </form>
  );
};

export default FranchiseeForm;